module.exports = __webpack_public_path__ + "static/media/webflow.2d42300e.svg";